import PropTypes from "prop-types";
import React, {Component} from "react";
import {YMaps, Map} from "react-yandex-maps";
import {connect} from "react-redux";

import {ActionCreator as ApplicationActionCreator} from "../reducers/application/application";
import {ActionCreator as DataActionCreator} from "../reducers/data/data";
import {AppRoute, MapColor} from "../const";
import {PoolPropType} from "../prop-types";
import {ResearchTemplate} from "../templates/research-template";
import {applyMobileMap, getPoolTotalResearches} from "../utils/utils";
import {getActiveDataMode, getActivePeriodId, getIsLabelLoad} from "../reducers/application/selectors";
import {getPools} from "../reducers/data/selectors";
import {history} from "../history";


const getCenterPixelCoordinates = (pixelGeometry) => {
  const x = pixelGeometry[0][0] + (pixelGeometry[1][0] - pixelGeometry [0][0]) / 2;
  const y = pixelGeometry[0][1] + (pixelGeometry[1][1] - pixelGeometry [0][1]) / 2;

  return [
    x,
    y,
  ];
};

const getTargetPixelCoordinates = (pixelGeometry) => {
  const x = pixelGeometry[1][0];
  const y = pixelGeometry[0][1] + (pixelGeometry[1][1] - pixelGeometry[0][1]) / 2;

  return [
    x,
    y,
  ];
};

const getMapCoordinates = (map, pixelCoordinates) => {
  const projection = map.options.get(`projection`);

  const mapCoordinates = projection.fromGlobalPixels(
      pixelCoordinates,
      map.getZoom()
  );

  return mapCoordinates;
};

const getOffset = (pool, balloon) => {
  const poolPixelGeometry = pool.getData().geometry.getPixelGeometry().getBounds();
  const centerPixelCoordinates = getCenterPixelCoordinates(poolPixelGeometry);
  const targetPixelCoordinates = getTargetPixelCoordinates(poolPixelGeometry);
  const offsetWidth = targetPixelCoordinates[0] - centerPixelCoordinates[0] + 2;
  const offsetHeight = balloon.getBoundingClientRect().height / 2;

  return {
    offsetWidth,
    offsetHeight,
  };
};

const getTextLayout = (pool) => {
  return `<div class="map__polygon-label">${pool.title}</div>`;
};

const getLabelDotLayout = () => {
  return `<div class="map__polygon-label-dot"></div>`;
};

const createBalloonLayout = (ymaps, pool, dataMode) => {
  const title = pool.title.replace(`рыбохозяйственный бассейн`, ``).replace(`ий `, `ом`).replace(`ый `, `ом`);
  const catchAreasCount = pool.catchAreas.length;
  const poolTotalResearches = getPoolTotalResearches(pool, dataMode);
  const researchTemplate = new ResearchTemplate(poolTotalResearches, `pool-balloon`).getTemplate();

  return (
    ymaps.templateLayoutFactory.createClass(
        `<div class="pool-balloon">
          <h5 class="pool-balloon__title">${pool.title}</h5>

          <p class="pool-balloon__catch-areas-count  catch-areas-count  catch-areas-count--pool-balloon">
            <span class="catch-areas-count__title  catch-areas-count__title--pool-balloon">Количество районов вылова водных биологических ресурсов в «${title} рыбохозяйственном бассейне»</span>
            <span class="catch-areas-count__count  catch-areas-count__count--pool-balloon">${catchAreasCount}</span>
          </p>

          <div class="research-balloon__research">
            ${researchTemplate}
          </div>
        </div>`, {
          build() {
            this.constructor.superclass.build.call(this);
            this._applyElementOffset.call(this);
          },

          getShape() {
            const el = this.getElement();
            let result = null;
            if (el) {
              const firstChild = el.firstChild;
              const offset = getOffset(this, firstChild);

              result = new ymaps.shape.Rectangle(
                  new ymaps.geometry.pixel.Rectangle([
                    [offset.offsetWidth, -offset.offsetHeight],
                    [offset.offsetWidth + firstChild.offsetWidth, firstChild.offsetHeight - offset.offsetHeight]
                  ])
              );
            }
            return result;
          },

          _applyElementOffset() {
            const balloon = this.getParentElement().querySelector(`.pool-balloon`);
            const offset = getOffset(this, balloon);
            balloon.style.transform = `translate(${offset.offsetWidth}px, ${-offset.offsetHeight}px)`;
          },
        }
    )
  );
};

const loadJS = (id, url, location, onLoad, onError) => {
  if (!document.getElementById(id)) {
    const scriptTag = document.createElement(`script`);
    location.appendChild(scriptTag);
    scriptTag.src = url;
    scriptTag.id = id;
    if (onLoad) {
      scriptTag.onload = onLoad;
    }
    if (onError) {
      scriptTag.onerror = onError;
    }
  }
};

const poolMouseenterHandler = (map, poolGeoObject) => {
  const poolObjectPixelGeometry = poolGeoObject.geometry.getPixelGeometry().getBounds();
  const centerPixelCoordinates = getCenterPixelCoordinates(poolObjectPixelGeometry);
  const centerCoordinates = getMapCoordinates(map, centerPixelCoordinates);

  poolGeoObject.options.set(`fillColor`, MapColor.FILL_COLOR_HOVER);
  poolGeoObject.options.set(`fillOpacity`, 0.6);
  poolGeoObject.balloon.open(centerCoordinates);
};

const poolMouseleaveHandler = (poolGeoObject) => {
  poolGeoObject.options.set(`fillColor`, MapColor.FILL_COLOR);
  poolGeoObject.options.set(`fillOpacity`, 0.2);
  poolGeoObject.balloon.close();
};

const poolClickHandler = (poolId, activePeriodId) => {
  history.push({
    pathname: AppRoute.POOL.replace(`:id`, poolId),
    search: activePeriodId ? `?period=${activePeriodId}` : ``,
  });
};


class MapMainComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ymaps: null,
    };

    this._mapRef = React.createRef();
    this._poolsCollection = null;
    this._polylabel = null;

    this._getMapState = this._getMapState.bind(this);
    this._handleMapLoad = this._handleMapLoad.bind(this);
    this._getLabels = this._getLabels.bind(this);
    this._applyMap = this._applyMap.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.activePeriodId !== this.props.activePeriodId) {
      return false;
    }

    return true;
  }

  componentDidMount() {
    const ymaps = this.state.ymaps;

    if (ymaps) {
      this._getLabels();
    }
  }

  componentDidUpdate() {
    const ymaps = this.state.ymaps;

    if (ymaps) {
      this._getLabels();
    }
  }

  _getMapState() {
    return {
      center: [52.047206, 87.780085],
      controls: [],
      zoom: 3,
    };
  }

  _handleMapLoad(newYmaps) {
    if (newYmaps) {
      this.setState({
        ymaps: newYmaps,
      }, this._getLabels);
    }
  }

  _getLabels() {
    const isLabelLoad = this.props.isLabelLoad;

    if (isLabelLoad) {
      this._applyMap();
    } else {
      let isCalculateAreaLoad = false;
      let isPolylabelLoad = false;

      loadJS(
          `calculateArea`,
          `https://yastatic.net/s3/mapsapi-jslibs/area/0.0.1/util.calculateArea.min.js`,
          document.head,
          (responceCalculateArea) => {
            isCalculateAreaLoad = responceCalculateArea.isTrusted;

            loadJS(
                `polylabel`,
                `https://yastatic.net/s3/mapsapi-jslibs/polylabeler/1.0.2/polylabel.min.js`,
                document.head,
                (responcePolylabel) => {
                  isPolylabelLoad = responcePolylabel.isTrusted;

                  if (isCalculateAreaLoad && isPolylabelLoad) {
                    this.props.onLabelLoad(true);
                  }

                  this._applyMap();
                },
                (error) => this.props.onError(error)
            );
          },
          (error) => this.props.onError(error)
      );
    }
  }

  _applyMap() {
    const pools = this.props.pools;
    const ymaps = this.state.ymaps;
    const myMap = this._mapRef.current;
    const oldPoolsCollection = this._poolsCollection;
    const newPoolsCollection = new ymaps.GeoObjectCollection();
    const dataMode = this.props.dataMode;
    const activePeriodId = this.props.activePeriodId;
    const labelDotLayout = getLabelDotLayout();

    const setNewPolylabel = (newPolylabel) => {
      if (this._polylabel) {
        this._polylabel.destroy();
      }
      this._polylabel = newPolylabel;
    };

    this._poolsCollection = newPoolsCollection;

    ymaps.ready([`polylabel.create`]).then(function () {
      pools.forEach((pool) => {
        const poolBalloonLayout = createBalloonLayout(ymaps, pool, dataMode);
        const textLayout = getTextLayout(pool);

        const poolGeoObject = new ymaps.GeoObject({
          geometry: {
            type: `Polygon`,
            coordinates: pool.coordinates,
          },
          properties: {
            pool,
          }
        }, {
          fillColor: MapColor.FILL_COLOR,
          fillOpacity: 0.2,
          strokeColor: MapColor.STROKE_COLOR,
          strokeWidth: 1,
          strokeStyle: `solid`,
          balloonLayout: poolBalloonLayout,
          // labelLayout: textLayout,
          // labelTextSize: {"2": 9, "3": 12, "4_18": 14},
          // labelPermissibleInaccuracyOfVisibility: 4,
          // labelCursor: `pointer`,
          // labelDotLayout,
          // labelDotCursor: `pointer`,
        });

        poolGeoObject.events.add(`mouseenter`, poolMouseenterHandler.bind(null, myMap, poolGeoObject));
        poolGeoObject.events.add(`mouseleave`, poolMouseleaveHandler.bind(null, poolGeoObject));
        poolGeoObject.events.add(`click`, poolClickHandler.bind(null, pool.id, activePeriodId));
        // poolGeoObject.events.add(`labelmouseenter`, poolMouseenterHandler.bind(null, myMap, poolGeoObject));
        // poolGeoObject.events.add(`labelclick`, poolClickHandler.bind(null, pool.id, activePeriodId));
        newPoolsCollection.add(poolGeoObject);
      });

      // const newPolylabel = ymaps.polylabel.create(myMap, newPoolsCollection);
      // setNewPolylabel(newPolylabel);

      if (oldPoolsCollection) {
        myMap.geoObjects.remove(oldPoolsCollection);
      }
      myMap.geoObjects.add(newPoolsCollection);
      myMap.setBounds(newPoolsCollection.getBounds());

      applyMobileMap(myMap);
    });
  }

  render() {
    const mapState = this._getMapState();

    return (
      <section className="map">
        <div className="map__container">
          <h2 className="visually-hidden">Интерактивная карта</h2>

          <div className="map__interactive" id="ymap-main">
            <YMaps
              query={{
                ns: `ymaps`,
                apikey: `03a72576-6326-46dd-9558-d211c7a8a216&lang=ru_RU`,
                load: `package.full`,
              }}
            >
              <Map
                instanceRef={this._mapRef}
                state={mapState}
                width={`100%`}
                height={`100%`}
                options={{
                  avoidFractionalZoom: false,
                  restrictMapArea: [[0, -89], [85, -90]],
                  suppressMapOpenBlock: true,
                  yandexMapDisablePoiInteractivity: true,
                }}
                onLoad={(ymaps) => this._handleMapLoad(ymaps)}
              >
              </Map>
            </YMaps>
          </div>
        </div>
      </section>
    );
  }
}


MapMainComponent.propTypes = {
  pools: PropTypes.arrayOf(PoolPropType).isRequired,
  dataMode: PropTypes.string.isRequired,
  activePeriodId: PropTypes.string.isRequired,
  isLabelLoad: PropTypes.bool.isRequired,
  onLabelLoad: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  pools: getPools(state),
  dataMode: getActiveDataMode(state),
  activePeriodId: getActivePeriodId(state),
  isLabelLoad: getIsLabelLoad(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLabelLoad(value) {
    dispatch(ApplicationActionCreator.setIsLabelLoad(value));
  },
  onError(error) {
    dispatch(DataActionCreator.setDataError(error));
  },
});

const MapMain = connect(mapStateToProps, mapDispatchToProps)(MapMainComponent);


export {
  MapMainComponent,
  MapMain,
};
